import './main.less';
import '../news-shared.less';
import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import cn from 'classname';

import LangSwitch from '../../../../shared/lang/switch';
import InputField from '../../../../shared/form-elements/input';
import TextField from '../../../../shared/form-elements/textarea';
import CheckboxField from '../../../../shared/form-elements/checkbox';
import SelectField from '../../../../shared/form-elements/select/field';

const Main = props => {
	const { shouldTranslate, selectOptions, disabledFields, isShouldPublishChecked } = props.formData;
	const submit = data => (shouldTranslate ? props.formSubmitTranslation(data) : props.formSubmit(data));
	const shouldDisabled = prepareDisabledFields(disabledFields);

	return (
		<div
			className={cn({
				'news-form-wrap': true,
				[props.className]: true
			})}
		>
			<div className="news-form-wrap__langs">
				<LangSwitch langs={props.formLangs} onChangeLang={props.formChangeLanguage} />
			</div>
			<form className="ui-form news-form__main clearfix" onSubmit={props.handleSubmit(submit)}>
				<div className="news-form__main-fields">
					<div className="news-group group-left">
						<div className="title-category-group">
							<div className="ui-form__element title">
								<Field
									name="title"
									placeholder={props.intl('Title')}
									component={InputField}
									disabled={shouldDisabled('title')}
								/>
							</div>

							<div className="ui-form__element category">
								<Field
									name="type"
									placeholder={props.intl('Category')}
									component={SelectField}
									searchable={false}
									multi={false}
									options={selectOptions['types']}
									disabled={shouldDisabled('type')}
								/>
							</div>
							<div className="ui-form__element category">
								<Field
									name="relevant_till"
									placeholder={props.intl('Relevant Till: %s', 'YYYY-MM-DD')}
									component={InputField}
									disabled={shouldDisabled('relevant_till')}
								/>
							</div>
						</div>

						<div className="ui-form__element offers">
							<Field
								name="news_offers"
								placeholder={props.intl('Offers')}
								component={SelectField}
								searchable={true}
								multi={true}
								options={props.offersLookups}
								disabled={shouldDisabled('news_offers')}
							/>
						</div>
						<div className="ui-form__element offers">
							<Field
								name="news_locations"
								placeholder={props.intl('Countries')}
								component={SelectField}
								searchable={true}
								multi={true}
								options={props.locationsLookup}
							/>
						</div>
						<span className="clearfix" />
					</div>

					<div className="news-group group-center">
						<div className="ui-form__element">
							<Field
								name="text"
								placeholder={props.intl('Text')}
								component={TextField}
								disabled={shouldDisabled('text')}
							/>
						</div>
					</div>

					<div className="news-group group-right">
						<div className="ui-form__element publish">
							<Field
								name="should_publish"
								placeholder={props.intl('Publish on website')}
								component={CheckboxField}
								disabled={shouldDisabled('should_publish')}
							/>
						</div>

						<div className="ui-form__element buttons-wrap">
							{props.can('edit') &&
								<button type="submit" className="ui-btn ui-btn-primary">
									{getSaveButtonText(shouldTranslate, isShouldPublishChecked, props.intl)}
								</button>}
						</div>
					</div>
				</div>
			</form>
		</div>
	);
};

const prepareDisabledFields = disabledFields => fieldName => disabledFields.indexOf(fieldName) > -1;

const getSaveButtonText = (shouldTranslate, isShouldPublishChecked, intl) => {
	let text;
	if (shouldTranslate) {
		text = intl('Save translation');
	} else if (isShouldPublishChecked) {
		text = intl('Publish');
	} else {
		text = intl('Save');
	}
	return text;
};

Main.propTypes = {
	className: PropTypes.string,
	formLangs: PropTypes.array,
	formData: PropTypes.object,
	handleSubmit: PropTypes.func,
	formSubmit: PropTypes.func,
	formSubmitTranslation: PropTypes.func,
	formChangeLanguage: PropTypes.func,
	offersLookups: PropTypes.func,
	intl: PropTypes.func,
	can: PropTypes.func
};

export default reduxForm({
	form: 'newsEditForm'
})(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/news/components/form/large/main.js